module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-lookup",
    attrs: {
      "id": _vm.getId
    }
  }, [_c('h4', [_vm._v("\n    " + _vm._s(this.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.address),
      expression: "location.address"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "address"
    },
    domProps: {
      "value": (_vm.location.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.street),
      expression: "location.street"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "street"
    },
    domProps: {
      "value": (_vm.location.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Town")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "styles": {
        input: {
          background: 'none',
          color: '#fff'
        }
      },
      "dataset": _vm.locationSearchResults,
      "initVal": _vm.initialLocation,
      "fnFormatText": _vm.locationFormat,
      "fnSelectValue": _vm.locationFormat
    },
    on: {
      "changing": function (data) { return _vm.locationSearch = data; },
      "selection-made": _vm.updateLocation
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "county"
    }
  }, [_vm._v("County")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.county),
      expression: "location.county"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "county"
    },
    domProps: {
      "value": (_vm.location.county)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "county", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.subdivision),
      expression: "location.subdivision"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state"
    },
    domProps: {
      "value": (_vm.location.subdivision)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "subdivision", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("Post code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.postCode),
      expression: "location.postCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "postcode"
    },
    domProps: {
      "value": (_vm.location.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "postCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.country),
      expression: "location.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country"
    },
    domProps: {
      "value": (_vm.location.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      Cancel\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e279b5ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationLookup.vue
// module id = 2287
// module chunks = 1